import { modifier } from "../modifiers";

modifier("strip", (value) => value.toString().trim());
